// extracted by mini-css-extract-plugin
export default {"icon":"FileAttachment_icon__ynfka","item":"FileAttachment_item__uY9rM"};